// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"87ff1a7f","110":"73634df2","391":"57747d93","437":"ee710539","569":"819acfcd","605":"80ad571a","626":"d3c46c1b","634":"ce8b6f8c","638":"7208679e","816":"5cf60b23","896":"3c7c0e86"}[chunkId] + ".chunk.js";
};